import { render, staticRenderFns } from "./ClassOverview.vue?vue&type=template&id=122ccc27&scoped=true&"
import script from "./ClassOverview.vue?vue&type=script&lang=js&"
export * from "./ClassOverview.vue?vue&type=script&lang=js&"
import style0 from "./ClassOverview.vue?vue&type=style&index=0&id=122ccc27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ccc27",
  null
  
)

export default component.exports